import React, { useState, useCallback, memo } from 'react';
import useAuth from '../hooks/useAuth';
import { isUserRole, ROLES } from '../utils/jwt';
import { ACCESS_TOKEN_USER } from '../const';
import DpaAgreementModal from './DpaAgreementModal';

const DpaAgreementBanner = () => {
  const { user } = useAuth();
  const role = isUserRole();
  const [accepted, setAccepted] = useState(false);

  const handleAccepted = useCallback(() => {
    setAccepted(true);
  }, []);

  const isKundvy = !!window.localStorage.getItem(ACCESS_TOKEN_USER);

  if (role !== ROLES.CUSTOMER || isKundvy) return null;
  if (!user?.dpaStatus || user.dpaStatus.accepted || user.dpaStatus.exempted || accepted) return null;

  return (
    <DpaAgreementModal
      open
      onAccepted={handleAccepted}
    />
  );
};

export default memo(DpaAgreementBanner);
